<ion-content>
  <div class="gmap-container">
    <div #gMap class="gmap" [ngClass]="{'browser': !isCordova}"></div>
    <div class="evs-card-ui toaster-invalid-address" [ngClass]="{'show': addressInvalid}">
      <div class="no-entry-icon"><img src="assets/svg/no-entry.svg" alt="EnvoitureSimone"></div>
      <div class="invalid-address-text">
        <h3>Adresse invalide</h3>
        <div>{{userAddress}}</div>
      </div>
    </div>
  </div>

  <modal-comp [compOptions]="{'id': 'customModalNoResults', size: 'small'}" *ngIf="modalNoResults" (canClose)="hideModalNoResults()">
    <div class="text-center">
      <p>Zut, il n’y a pas encore de point de rendez-vous près de chez toi…</p>
      <button class="btn full-width" (click)="resetInput()">Chercher une autre adresse</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalNoGeoloc', size: 'small'}" *ngIf="modalNoGeoloc" (canClose)="hideModalNoGeoloc()">
    <div class="text-center">
      <p>{{noGeolocText}}</p>
      <button class="btn full-width" (click)="hideModalNoGeoloc()">J'ai compris</button>
    </div>
  </modal-comp>

</ion-content>